import { Atom01, SearchSm, Mail01, Users01 } from '@kula-ai/icons-core';
import type { FC } from 'react';

interface MinStep {
  id: string;
  name: string;
}

// StepIcon renders the leading icon for a timeline step. Action steps
// (id prefixed with `action:`) get the atom mark; tool steps look at the
// raw tool name. Returning JSX with statically-referenced icon components
// (rather than handing back a component type to render) keeps this clear
// of react-hooks/static-components. Falls back to the atom mark used
// everywhere else in the chat surface so nothing renders blank.
export const StepIcon: FC<{ step: MinStep; size?: number; color?: string }> = ({
  step,
  size = 14,
  color = 'currentColor',
}) => {
  if (step.id.startsWith('action:')) {
    // Routing, context, compose all use the atom for now — the *label*
    // is what differentiates them, and visually-noisy icon swapping
    // makes the timeline harder to scan, not easier.
    return <Atom01 size={size} color={color} />;
  }
  const name = step.name.toLowerCase();
  if (name === 'send_email') return <Mail01 size={size} color={color} />;
  if (name.startsWith('kula_contact_'))
    return <Users01 size={size} color={color} />;
  if (
    name === 'kula_search' ||
    name === 'web_search' ||
    name === 'knowledge_search' ||
    name.endsWith('_search') ||
    name.endsWith('_get') ||
    name.endsWith('_list')
  ) {
    return <SearchSm size={size} color={color} />;
  }
  return <Atom01 size={size} color={color} />;
};
